define(["./raphael.core", "./raphael.svg", "./raphael.vml"], function(R) {

    return R;

});


/*****************
 ** WEBPACK FOOTER
 ** ./~/@feith/raphael/dev/raphael.amd.js
 ** module id = 182
 ** module chunks = 0
 **/